import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./oops.${locale}.json`));
